import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';

/**
 * for this page
 */
import Header from '../../../index/layout/header';
import Footer from '../../../components/footer';

import Content from './content';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {};

    render() {
        const { content } = this.props;

        const { nav, topAd, footer, search, logo, mainNavData, subNav, tabNav } = content;
        const headerCon = { nav, topAd, search, logo, mainNavData };
        const contentData = { subNav, tabNav };

        return (
            <div className={styles.layout}>
                <Header content={headerCon} />
                <div className={styles.headAd} />
                <Content content={contentData} />
                <Footer content={footer} />
                <ChipEdit transform={transform} />
            </div>
        );
    }
}

export default Layout;
